export enum VideoFormat {
  Center = 'center',
  Fullscreen = 'fullscreen',
}
